<template>
    <div>
        <div v-if="isLoading">
            <div class="row">
                <div class="col my-4 text-center">
                    <img class="mx-auto" style="height: 25px;" src="/themes/brekz-2017/img/loading-indicator-l.gif">
                    <b class="ml-1 my-auto">{{ $t("myAccount.loading") }}</b>
                </div>
            </div>
        </div>

        <div v-else>
            <div class="row no-gutters py-3">
                <div class="col-12 mb-3">
                    <button id="address-create-component"
                            class="button-brekz button-brekz--rounded button-brekz--green"
                            :class="[isMobile ? 'ml-2' : '']"
                            v-on:click="openCreateAddressCollapse()"
                            v-if="!isCreateAddressCollapseOpen">
                        <i class="fas fa-plus"></i>
                        {{ $t("myAccount.addAddress") }}
                    </button>
                </div>
                <div class="col-12 mb-3">
                    <div id="collapse_create_address" class="collapse" aria-expanded="false">
                        <address-create @close="closeCreateAddressCollapse()"
                                        @new-address-data="getAddresses()"
                                        @default-address-changed="defaultAddressChanged"
                                        @error-occurred="showErrorModal()"
                                        @clear-address-copy-data="clearAddressCopyData()"
                                        :countries="addresses.countries"
                                        :address-copy-data="addressCopyData"
                                        :get-address-link="getAddressLink"
                                        current-type="account"
                                        :default-country-id="defaultCountryId"

                        ></address-create>
                    </div>
                </div>
                <div v-for="address in addresses.addresses" class="col-12 mb-5">
                    <div class="account__card pt-2 account__card--shadow">
                        <div class="account__border">
                            <div :id="'card_' + address.id_address" class="account__card--topbar account__card--topbar--padding d-flex align-items-center">
                                <div class="text--green font-weight-bold" v-text="address.address +', ' + address.city"></div>
                                <div v-if="address.default_address" class="account--status ml-3 py-1 px-3 d-none d-md-block">
                                    <i class="fas fa-check mr-2"></i>{{ $t("myAccount.defaultAddress") }}
                                </div>
                                <button class="text-center button-brekz button-brekz--rounded button-brekz--yellow button--icon-left text--gray-600 ml-auto"
                                        @click="editAddress(address.id_address)"
                                        v-if="!isEditCollapseOpen(address.id_address)">
                                    <i class="fas fa-pencil-alt mr-2"></i>
                                    <span class="d-none d-md-inline-block">{{ $t("myAccount.adjust") }}</span>
                                </button>
                            </div>
                        </div>
                            <div :class="{'account__border' : !isEditCollapseOpen(address.id_address)}">
                                <div :id="'collapse_' + address.id_address" class="pt-3 collapse" aria-expanded="false">
                                    <address-edit :address="address"
                                                  :countries="addresses.countries"
                                                  :default-country-id="defaultCountryId"
                                                  :get-address-link="getAddressLink"
                                                  @error-occurred="showErrorModal()"
                                                  @default-address-changed="defaultAddressChanged"
                                                  @address-updated="refreshAddressItem"
                                                  @address-id-changed="getAddresses"
                                                  @close="closeEditCollapse(address.id_address)"></address-edit>
                                </div>

                                <div v-if="!isEditCollapseOpen(address.id_address)" class="account--padding py-3">
                                    <div class="row">
                                        <div class="col-12 col-sm-4">
                                            <div class="mb-2 text--gray-mid">
                                                <i class="fas fa-user mr-2 d-none d-sm-inline-block"></i><span class="d-none d-sm-inline-block">{{ $t("myAccount.name") }}</span>
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <i class="fas fa-user text--gray-mid d-block d-sm-none mr-4"></i>
                                                <div class="account--text-cutter">{{address.first_name}} {{address.last_name}}</div>
                                            </div>

                                        </div>
                                        <div class="col-12 col-sm-4">
                                            <div class="mb-2 text--gray-mid">
                                                <i class="fas fa-home mr-2 d-none d-sm-inline-block"></i><span class="d-none d-sm-inline-block">{{ $t("myAccount.address") }}</span>
                                            </div>
                                            <div class="d-flex  align-items-center">
                                                <i class="fas fa-home text--gray-mid d-block d-sm-none mr-4"></i>
                                                <div class="w-100">
                                                    <div class="account--text-cutter">{{ address.address }}
                                                        {{ address.house_number }}</div>
                                                    <div class="account--text-cutter">{{address.postcode}} {{address.city}}</div>
                                                    <div v-if="address.address2 !== ''" class="account--text-cutter">
                                                        {{ address.address }}
                                                    </div>
                                                    <input type="hidden" :id="'copy-address-' + address.id_address" :value="address.address + ', ' + address.postcode + ' ' + address.city">
                                                </div>
                                            </div>

                                        </div>
                                        <div class="col-12 col-sm-4">
                                            <div class="mb-2 text--gray-mid">
                                                <i class="fas fa-phone mr-2 d-none d-sm-inline-block"></i><span class="d-none d-sm-inline-block">{{ $t("myAccount.phone") }}</span>
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <i class="fas fa-phone text--gray-mid d-block d-sm-none mr-4"></i>
                                                <div class="d-inline-block d-md-block" v-text="address.phone"></div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="!isEditCollapseOpen(address.id_address)" class="account__card--bottom-bar">
                                <div class="d-flex align-items-center w-100 py-2" :class="[isMobile ? 'justify-content-between' : 'justify-content-end']">
                                    <div class="mr-2 d-flex align-items-center">
                                        <a :title="$t('myAccount.copyAddress')" href="#address-create" @click="copyAddress(address)" class=" text--gray-mid text--xs">
                                            <i class="fas fa-copy mr-2"></i>{{ $t("myAccount.copyAddress") }}
                                        </a>
                                    </div>
                                    <div class="mr-2 h-100 d-flex align-items-center">
                                        <a title="Set default Address" href="#" v-on:click="setDefaultAddress(address.id_address)" class="text--green text--xs">
                                            <div :class="[ !address.default_address ? 'text--gray-mid' : '']">
                                                <i class="mr-2" :class="[ !address.default_address ? 'fas fa-star' : 'fas fa-check' ]"></i>
                                                <span v-if="address.default_address">{{ $t('myAccount.defaultAddress') }}</span>
                                                <span v-else>{{ $t('myAccount.setAsDefaultAddress') }}</span>
                                            </div>
                                        </a>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <a title="Delete address" href="#" v-on:click="openDeleteAddressModal(address.id_address)" class="text--gray-mid text--xs">
                                            <i class="fas fa-trash mr-2"></i>{{ $t("myAccount.delete") }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
            <modal-vue @confirm="deleteAddress(addressToDelete)"
                       @cancel="emitCancel()"
                       :title="$t('myAccount.delete')"
                       :show="showConfirm"
                       width="xs"
                       :buttons="addressDeleteButtons">
                <p class="py-3">{{ $t("myAccount.deleteAddressModalText") }}</p>
            </modal-vue>

            <modal-vue :title="$t('myAccount.deleteAddressModalLoaderText')"
                       :show="isRemovingAddress">
                <p class="mb-1 mt-3 text-center">{{ $t("myAccount.deleteAddressModalLoaderText") }}</p>
                <div class="d-flex w-100 mb-3">
                    <img class="mx-auto" style="height: 25px;" src="/themes/brekz-2017/img/loading-indicator-l.gif">
                </div>
            </modal-vue>
        </div>

        <modal-vue title=":("
                   :show="showModal"
                   @close="closeModal()"
                   width="xs"
                   :buttons='[{text: $i18n.t("myAccount.close"), class: "button-brekz button-brekz--rounded button-brekz--green button--extra-large mx-auto", emit_name: "close"}]'>
            <p class="my-3 mx-3">{{ $t("myAccount.errorModalText") }}<br/>{{ $t("myAccount.errorModalText2") }}</p>
        </modal-vue>
    </div>
</template>

<script>
    import ErrorMessage from "./ErrorMessage";
    import AddressCreate from "./AddressCreate";
    import AddressEdit from "./AddressEdit";
    import ModalVue from "./ModalVue";

    export default {
        name: "Address",
        components: { AddressEdit, AddressCreate, ErrorMessage, ModalVue },
        props: {
            isMobile: {
                type: Boolean
            },
            defaultCountryId: {
                type: Number
            },
            getAddressLink: {
                type: String
            },
            createAddressLink: {
                type: String
            },
        },
        data() {
            return {
                count: 0,
                isLoading: true,
                addresses: [],
                openEditCollapses: [],
                addressCopyData: {},
                formStatus: null,
                isCreateAddressCollapseOpen: false,
                showConfirm: false,
                addressToDelete: null,
                isRemovingAddress: false,
                showModal: false,
                addressDeleteButtons: [
                    {
                        text: this.$t('myAccount.cancel'),
                        class: "button-brekz",
                        emit_name: "cancel"
                    },
                    {
                        text: this.$t('myAccount.delete'),
                        class: "button--extra-large button-brekz button-brekz--rounded button-brekz--yellow text--gray-600",
                        emit_name: "confirm"
                    }
                ]
            }
        },
        methods: {
            getAddresses() {
                this.isLoading = true;

                jQuery.ajax(`${this.getAddressLink}?action=all`, {
                    type: "GET",
                    success: response => {
                        this.addresses = response;
                        this.isLoading = false;
                        this.openEditCollapses = [];
                    },
                    error: XMLHttpRequest => {
                        this.showErrorModal();
                        console.log('Address fetch failed', XMLHttpRequest.responseText);
                    }
                });
            },
            copyAddress(address) {
                this.addressCopyData = address;

                this.openCreateAddressCollapse();
            },
            clearAddressCopyData() {
                this.addressCopyData = {};
            },
            setDefaultAddress(addressId) {
                if (!this.isAddressDefaultAddress(addressId)) {
                    this.isLoading = true;

                    jQuery.ajax(`${this.getAddressLink}?action=default&id_address=${addressId}`, {
                        type: "POST",
                        success: response => {
                            this.getAddresses();
                        },
                        error: XMLHttpRequest => {
                            this.isLoading = false;
                            this.showErrorModal();
                            console.log('standard address update failed', XMLHttpRequest.responseText);
                        }
                    });
                }
            },
            isAddressDefaultAddress(addressId) {
                for (var i = 0; i < this.addresses.addresses.length; i++) {
                    if (parseInt(this.addresses.addresses[i].id_address) === parseInt(addressId)) {
                        return this.addresses.addresses[i].default_address;
                    }
                }
            },
            showErrorModal() {
                this.showModal = true;
                document.body.classList.add("modal-vue--open");
            },
            closeModal() {
                this.showModal = false;
                document.body.classList.remove("modal-vue--open");
            },
            defaultAddressChanged(value) {
                this.setDefaultAddress(value.id_address);
            },
            openCreateAddressCollapse() {
                this.isCreateAddressCollapseOpen = true;
                $('#collapse_create_address').collapse('show');
            },
            closeCreateAddressCollapse() {
                this.isCreateAddressCollapseOpen = false;
                $('#collapse_create_address').collapse('hide');
            },
            isEditCollapseOpen(collapseId) {
                for (let i = 0; i < this.openEditCollapses.length; i++) {
                    if (this.openEditCollapses[i] === collapseId) {
                        return true;
                    }
                }

                return false;
            },
            refreshAddressItem(value) {
                for (let i = 0; i < this.addresses.addresses.length; i++) {
                    if (this.addresses.addresses[i].id_address === value.addressData.id_address) {
                        let alias = value.addressData.address + ' ' + value.addressData.city;

                        this.addresses.addresses[i] = value.addressData;
                        this.addresses.addresses[i].alias = alias;
                        break;
                    }
                }
            },
            closeEditCollapse(collapseId) {
                for (let i = 0; i < this.openEditCollapses.length; i++) {
                    if (this.openEditCollapses[i] === collapseId) {
                        this.openEditCollapses.splice(i,1);
                    }
                }
                $('#collapse_' + collapseId).collapse('hide');
            },
            editAddress(addressId) {
                this.$nextTick(() => {
                    this.openEditCollapses.push(addressId);
                    $('#collapse_' + addressId).collapse('show');
                    $('#collapse_' + addressId).on('shown.bs.collapse', function() {
                        let headerHeight;
                        let menuMobile;
                        let topOfElement;
                        let targetElement = document.getElementById('card_' + addressId);

                        if (isMobile) {
                            headerHeight = document.getElementById('header').clientHeight;
                            menuMobile   = document.getElementById('header').clientHeight;
                            topOfElement = window.pageYOffset + targetElement.getBoundingClientRect().top - (headerHeight + menuMobile);
                        } else {
                            headerHeight = document.getElementById('js-header').clientHeight;
                            topOfElement = window.pageYOffset + targetElement.getBoundingClientRect().top - headerHeight;
                        }

                        if ('scrollBehavior' in document.documentElement.style) {
                            window.scroll({ top: topOfElement, behavior: "smooth" });
                        } else {
                            window.scrollTo(0, topOfElement);
                        }

                    });
                });
            },
            deleteAddress(addressId) {
                let address = "";
                this.showConfirm = false;
                this.isRemovingAddress = true;


                for (let i = 0; i < this.addresses.addresses.length; i++) {
                    if (this.addresses.addresses[i].id_address === addressId) {
                        address = this.addresses.addresses[i].alias;
                        break;
                    }
                }

                jQuery.ajax(`${this.getAddressLink}?action=delete&id_address=${addressId}`, {
                    type: "GET",
                    success: response => {
                        this.isRemovingAddress = false;
                        document.body.classList.remove("modal-vue--open");
                        this.getAddresses();
                    },
                    error: XMLHttpRequest => {
                        this.showErrorModal()
                        this.isRemovingAddress = false;
                    }
                });
            },
            emitCancel(){
                document.body.classList.remove("modal-vue--open");
                this.showConfirm = false;
            },
            openDeleteAddressModal(id_address) {
                this.addressToDelete = id_address;
                this.showConfirm = true;
                document.body.classList.add("modal-vue--open");
            }
        },
        mounted() {
            this.getAddresses();
        }
    }
</script>
